module.exports = "./img/c4bf46d07911d9f2743a80c01aa6ef68.png";